import { FC } from 'react';
import { useIntl } from 'react-intl';
import { RichText } from '@fe-core-ui/src/components/RichText';
import { Details } from './Details';
import { useFilterCategoryData } from '@hooks/useFilterCategoryData';
import { TabPage } from '@routes/session-details/components/TabPage';
import { TEnrollment } from '@api/io/session.io';

export type OverviewSessionDetails = {
  description?: string | null;
  language?: string | null;
  timezone?: string | null;
  enrollment?: TEnrollment;
  duration?: number | null;
  categories?: number[];
};

type OverviewTabProps = {
  sessionDetails: OverviewSessionDetails;
};
const Separator = () => <div className="lf:my-8 lf:border-b-1 lf:border-neutral-100" />;

export const OverviewTab: FC<OverviewTabProps> = ({ sessionDetails }) => {
  const intl = useIntl();
  const { categoryData } = useFilterCategoryData({
    selectedCategoryId: null,
  });

  return (
    <TabPage
      className="lf:gap-0"
      title={intl.formatMessage({ id: 'catalog.tab.overview.title' })}
    >
      {sessionDetails.description && (
        <RichText>{sessionDetails.description}</RichText>
      )}
      <Separator />
      <Details
        sessionDetails={sessionDetails}
        categories={categoryData?.flatCategories}
        collectionName={'test'}
      />
    </TabPage>
  );
};
